import { render } from "./topBarY.vue?vue&type=template&id=a675640e&scoped=true"
import script from "./topBarY.vue?vue&type=script&lang=js"
export * from "./topBarY.vue?vue&type=script&lang=js"

import "./topBarY.vue?vue&type=style&index=0&id=a675640e&scoped=true&lang=css"

import exportComponent from "D:\\dev_workspace\\cy\\web\\linkomweb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a675640e"]])

export default __exports__